/* Rekover — theme scripts. No dependencies. */
(function () {
  'use strict';

  document.documentElement.classList.add('js');

  /* ---------- Mobile menu ---------- */
  function initMenuDrawer() {
    var drawer = document.querySelector('[data-menu-drawer]');
    if (!drawer) return;
    var header = drawer.closest('.header');
    drawer.addEventListener('toggle', function () {
      if (header) {
        var rect = header.getBoundingClientRect();
        document.documentElement.style.setProperty('--drawer-top', Math.max(rect.bottom, 0) + 'px');
      }
      document.body.style.overflow = drawer.open ? 'hidden' : '';
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && drawer.open) {
        drawer.open = false;
        var toggle = drawer.querySelector('summary');
        if (toggle) toggle.focus();
      }
    });
  }

  /* ---------- Quantity steppers ---------- */
  function initQuantity(root) {
    (root || document).querySelectorAll('[data-qty]').forEach(function (wrapper) {
      if (wrapper.dataset.qtyReady) return;
      wrapper.dataset.qtyReady = 'true';
      var input = wrapper.querySelector('input');
      if (!input) return;
      function step(delta) {
        var min = input.min !== '' ? parseInt(input.min, 10) : 0;
        var max = input.max !== '' ? parseInt(input.max, 10) : 999;
        var value = parseInt(input.value, 10) || 0;
        var next = Math.min(max, Math.max(min, value + delta));
        if (next !== value) {
          input.value = next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      var minus = wrapper.querySelector('[data-qty-minus]');
      var plus = wrapper.querySelector('[data-qty-plus]');
      if (minus) minus.addEventListener('click', function () { step(-1); });
      if (plus) plus.addEventListener('click', function () { step(1); });
    });
  }

  /* ---------- Cart page: auto-update on quantity change ---------- */
  function initCart() {
    var form = document.getElementById('CartForm');
    if (!form) return;
    var timer;
    form.addEventListener('change', function (event) {
      if (!event.target.matches('[data-cart-qty]')) return;
      clearTimeout(timer);
      timer = setTimeout(function () { form.submit(); }, 450);
    });
  }

  /* ---------- Product gallery ---------- */
  function showMedia(section, mediaId) {
    if (!mediaId) return;
    var items = section.querySelectorAll('[data-media-id]');
    var found = false;
    items.forEach(function (item) {
      var match = String(item.dataset.mediaId) === String(mediaId);
      item.classList.toggle('is-active', match);
      if (match) found = true;
    });
    if (!found) return;
    section.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      var match = String(thumb.dataset.thumb) === String(mediaId);
      thumb.classList.toggle('is-active', match);
      if (match) { thumb.setAttribute('aria-current', 'true'); } else { thumb.removeAttribute('aria-current'); }
    });
  }

  function initGallery(section) {
    section.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () { showMedia(section, thumb.dataset.thumb); });
    });
  }

  /* ---------- Variant picker ---------- */
  function formatMoney(cents, section) {
    var currency = section.dataset.currency || 'EUR';
    var locale = section.dataset.locale || document.documentElement.lang || 'fr';
    try {
      return new Intl.NumberFormat(locale + '-BE', { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }
  }

  function initVariantPicker(section) {
    var picker = section.querySelector('[data-variant-picker]');
    if (!picker) return;
    var json = picker.querySelector('[data-variants-json]');
    if (!json) return;
    var variants;
    try { variants = JSON.parse(json.textContent); } catch (e) { return; }

    var idInput = section.querySelector('[data-variant-id]');
    var addButton = section.querySelector('[data-add-button]');
    var addLabel = section.querySelector('[data-add-label]');
    var priceWrap = section.querySelector('[id^="Price-"]');
    var labels = {
      add: addLabel ? addLabel.textContent.trim() : '',
      soldOut: section.dataset.soldOut || 'Épuisé',
      unavailable: section.dataset.unavailable || 'Indisponible'
    };
    if (addButton && addButton.disabled) labels.add = section.dataset.addLabel || 'Ajouter au panier';

    function selectedOptions() {
      var groups = picker.querySelectorAll('fieldset');
      var values = [];
      groups.forEach(function (group) {
        var checked = group.querySelector('input:checked');
        values.push(checked ? checked.value : null);
      });
      return values;
    }

    function update() {
      var options = selectedOptions();
      var variant = variants.find(function (v) {
        return v.options.every(function (value, index) { return value === options[index]; });
      });

      if (!variant) {
        if (addButton) addButton.disabled = true;
        if (addLabel) addLabel.textContent = labels.unavailable;
        return;
      }

      if (idInput) idInput.value = variant.id;
      if (addButton) addButton.disabled = !variant.available;
      if (addLabel) addLabel.textContent = variant.available ? labels.add : labels.soldOut;

      if (priceWrap) {
        var current = priceWrap.querySelector('.price__current');
        var compare = priceWrap.querySelector('.price__compare');
        if (current) current.textContent = formatMoney(variant.price, section);
        var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        priceWrap.classList.toggle('price--sale', !!onSale);
        if (onSale) {
          if (!compare) {
            compare = document.createElement('s');
            compare.className = 'price__compare';
            priceWrap.appendChild(compare);
          }
          compare.textContent = formatMoney(variant.compare_at_price, section);
        } else if (compare) {
          compare.remove();
        }
      }

      if (variant.featured_media) showMedia(section, variant.featured_media.id);

      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    picker.addEventListener('change', update);
  }

  /* ---------- Product recommendations ---------- */
  function initRecommendations() {
    document.querySelectorAll('[data-recommendations]').forEach(function (container) {
      var url = container.dataset.url;
      if (!url || container.dataset.loaded) return;
      container.dataset.loaded = 'true';
      fetch(url)
        .then(function (response) { return response.text(); })
        .then(function (text) {
          var html = document.createElement('div');
          html.innerHTML = text;
          var fresh = html.querySelector('[data-recommendations]');
          if (fresh && fresh.innerHTML.trim().length) {
            container.innerHTML = fresh.innerHTML;
          }
        })
        .catch(function () {});
    });
  }

  /* ---------- Login: toggle password recovery ---------- */
  function initRecover() {
    var recover = document.getElementById('RecoverPassword');
    var login = document.getElementById('CustomerLogin');
    if (!recover || !login) return;
    function toggle() {
      var showRecover = recover.hidden;
      recover.hidden = !showRecover;
      login.hidden = showRecover;
    }
    document.querySelectorAll('[data-toggle-recover]').forEach(function (button) {
      button.addEventListener('click', toggle);
    });
    if (window.location.hash === '#recover') toggle();
  }

  function init() {
    initMenuDrawer();
    initQuantity();
    initCart();
    initRecover();
    initRecommendations();
    document.querySelectorAll('[data-product-section]').forEach(function (section) {
      initGallery(section);
      initVariantPicker(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Theme editor: re-init a section after it is reloaded */
  document.addEventListener('shopify:section:load', function (event) {
    initQuantity(event.target);
    initRecommendations();
    event.target.querySelectorAll('[data-product-section]').forEach(function (section) {
      initGallery(section);
      initVariantPicker(section);
    });
  });
})();

/* Apparition douce au défilement */
(function () {
  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var selector = '.tile, .gallery__item, .card, .feature, .step, .section-head, .quote';
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) { entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  function scan(root) {
    root.querySelectorAll(selector).forEach(function (el, i) {
      if (el.classList.contains('reveal')) return;
      el.classList.add('reveal');
      el.style.transitionDelay = (i % 4) * 70 + 'ms';
      io.observe(el);
    });
  }
  scan(document);
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); e.target.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-visible'); }); });
})();
